module.exports = __webpack_public_path__ + "static/media/burger.ee7e96ab.svg";